import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import Twotone from "../../assets/img/Twotone.svg";
import { convertCurrencyFormat } from "../../helper/common";
import {
  getOwnRetaAnalysisDocs,
  isRetaRequired,
} from "../../Utils/retaRequirement";
import { Card, Notice } from "../design";
import "./tenantInfoCards.css";

// Landlord view, freelancers only: the tenant's RETA receipts (Recibo de
// cuota de autónomos) with the amounts Skor lite read from them, one tile per
// receipt like the old payslip tiles. For information only: never part of
// the income or the effort rate.
const DetailsRetaReceipts = ({ user = null }) => {
  const { _t } = useTranslator();

  if (!isRetaRequired(user)) return null;

  const receipts = getOwnRetaAnalysisDocs(
    user?.tenant_extra_field_id?.document_analysis?.profileReports ??
      user?.tenant_extra_id?.document_analysis?.profileReports
  )
    .map((doc) => {
      const payments = doc?.socialSecurityPayments ?? [];
      const periodYear = Number(doc?.period_year ?? doc?.data?.period_year);
      const periodMonth = Number(doc?.period_month ?? doc?.data?.period_month);
      const chargeDate = payments.find(
        (payment) => payment?.charge_date
      )?.charge_date;
      return {
        key: doc?.instanceId ?? `${periodYear}-${periodMonth}`,
        amount: payments.reduce(
          (sum, payment) => sum + (Number(payment?.amount) || 0),
          0
        ),
        hasAmount: payments.some((payment) => payment?.amount != null),
        sortKey: periodYear * 100 + periodMonth || 0,
        date: chargeDate
          ? moment(chargeDate).format("DD/MM/YYYY")
          : periodYear && periodMonth
            ? `${String(periodMonth).padStart(2, "0")}/${periodYear}`
            : null,
      };
    })
    .filter((receipt) => receipt.hasAmount)
    .sort((a, b) => b.sortKey - a.sortKey);

  return (
    <Card
      className="tic-card mt-3"
      title={
        <span className="tic-card__title">
          <img src={Twotone} alt="" className="tic-card__icon" />
          {_t(
            "retaReceipts",
            "Title of the RETA receipts card in the landlord view of a freelancer tenant profile"
          )}
        </span>
      }
    >
      {receipts.length > 0 ? (
        <>
          <div className="row">
            {receipts.map((receipt) => (
              <div className="col-md-4 col-6" key={receipt.key}>
                <div className="tic-field">
                  <p className="tic-field__value">
                    €{convertCurrencyFormat(receipt.amount)}
                    {receipt.date && ` (${receipt.date})`}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <p className="tic-field__note mt-2">
            {_t(
              "retaReceiptsNotIncome",
              "Note under the landlord RETA receipts card saying the amounts are not counted as income"
            )}
          </p>
        </>
      ) : (
        <Notice>
          {_t(
            "noEntriesFound",
            "Shown in the landlord RETA receipts card when the tenant has no RETA receipt"
          )}
        </Notice>
      )}
    </Card>
  );
};

export default DetailsRetaReceipts;
